import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withCtx as _withCtx, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "content flex-row-fluid" }
const _hoisted_2 = { class: "page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "d-flex align-items-center text-dark fw-bolder fs-3 my-5" }, "Danh sách ứng viên", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "h-20px border-gray-400 border-start mx-4" }, null, -1)
const _hoisted_5 = { class: "breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1" }
const _hoisted_6 = { class: "breadcrumb-item text-muted" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "/dashboard",
  class: "text-muted text-hover-primary"
}, "Dashboard", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left me-1" }, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "row g-2 mb-4"
}
const _hoisted_11 = { class: "d-flex align-items-center bg-white rounded py-2 px-4 h-100 border-start border-3 border-warning" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle-fill text-warning fs-5 me-3 flex-shrink-0" }, null, -1)
const _hoisted_13 = { class: "flex-grow-1 fs-7" }
const _hoisted_14 = { class: "fw-bolder text-gray-800" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, " — chưa chọn ngành / ngành đã xoá, cần xử lý.", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted mx-2" }, "·", -1)
const _hoisted_17 = { class: "d-flex align-items-center bg-white rounded py-2 px-4 h-100 border-start border-3 border-warning" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle-fill text-warning fs-5 me-3 flex-shrink-0" }, null, -1)
const _hoisted_19 = { class: "flex-grow-1 fs-7" }
const _hoisted_20 = { class: "fw-bolder text-gray-800" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, " — nên kiểm tra / liên hệ xử lý.", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted mx-2" }, "·", -1)
const _hoisted_23 = { class: "card" }
const _hoisted_24 = { class: "card-body pt-5 umt-table-compact" }
const _hoisted_25 = { class: "d-flex align-items-center position-relative" }
const _hoisted_26 = { class: "svg-icon svg-icon-3 position-absolute ms-4" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-icon btn-sm btn-secondary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots-vertical" })
], -1)
const _hoisted_28 = {
  class: "menu menu-sub menu-sub-dropdown w-250px py-2 menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold dropdown-menu",
  "data-kt-menu": "true"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-plus fs-5 me-3 text-primary" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-1" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-arrow-up fs-5 me-3 text-gray-500" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-arrow-down fs-5 me-3 text-gray-500" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-1" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-arrow-down fs-5 me-3 text-success" }, null, -1)
const _hoisted_35 = {
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_import_dataentry",
  class: "menu-item dropdown-item px-3 py-2 cursor-pointer d-flex align-items-center text-gray-800 fw-semibold text-hover-primary"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-arrow-up fs-5 me-3 text-primary" }, null, -1)
const _hoisted_37 = {
  key: 0,
  class: "d-flex align-items-center gap-2 flex-nowrap flex-grow-1",
  "data-kt-customer-table-toolbar": "selected"
}
const _hoisted_38 = {
  class: "badge badge-light-primary fs-8 py-2 px-3 d-flex align-items-center text-nowrap",
  style: {"height":"32px"}
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2-square me-1" }, null, -1)
const _hoisted_40 = ["title"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-arrow-down me-1" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-check me-1" }, null, -1)
const _hoisted_43 = ["title"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash me-1" }, null, -1)
const _hoisted_45 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_46 = ["value"]
const _hoisted_47 = { class: "text-nowrap" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = {
  key: 0,
  class: "bi bi-award-fill text-success fs-7 ms-1",
  title: "Đã trúng tuyển"
}
const _hoisted_50 = { key: 0 }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("i", { class: "text-danger bi bi-info-circle" }, null, -1)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = {
  key: 1,
  class: "text-muted fs-8"
}
const _hoisted_54 = { class: "d-flex flex-column" }
const _hoisted_55 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_56 = {
  key: 0,
  class: "text-muted fs-8 mt-1 pe-2"
}
const _hoisted_57 = { class: "text-center text-nowrap" }
const _hoisted_58 = {
  key: 0,
  class: "badge badge-light-success fw-normal",
  title: "Đã khớp Bộ GD&ĐT đủ cả học bạ + điểm thi TN"
}
const _hoisted_59 = {
  key: 1,
  class: "badge badge-light-info fw-normal",
  title: "Mới khớp HỌC BẠ — chưa khớp điểm thi TN"
}
const _hoisted_60 = {
  key: 2,
  class: "badge badge-light-info fw-normal",
  title: "Mới khớp ĐIỂM THI TN — chưa khớp học bạ"
}
const _hoisted_61 = {
  key: 3,
  class: "text-gray-400"
}
const _hoisted_62 = {
  class: "modal fade",
  id: "kt_modal_assign",
  ref: "assigneeModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_63 = { class: "modal-dialog modal-dialog-centered mw-550px" }
const _hoisted_64 = { class: "modal-content" }
const _hoisted_65 = {
  class: "modal-header p-3",
  id: "kt_modal_add_customer_header"
}
const _hoisted_66 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Gán người phụ trách", -1)
const _hoisted_67 = {
  id: "kt_modal_add_customer_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_68 = { class: "svg-icon svg-icon-1" }
const _hoisted_69 = { class: "modal-body py-5 px-lg-8" }
const _hoisted_70 = { class: "fs-7 mb-3" }
const _hoisted_71 = { class: "text-muted" }
const _hoisted_72 = { class: "text-gray-800" }
const _hoisted_73 = {
  key: 0,
  class: "text-muted mt-1"
}
const _hoisted_74 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle-fill text-warning me-1" }, null, -1)
const _hoisted_75 = { class: "text-gray-800" }
const _hoisted_76 = {
  key: 0,
  class: "text-gray-800"
}
const _hoisted_77 = /*#__PURE__*/_createElementVNode("b", null, "thay thế", -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder" }, "Gán theo", -1)
const _hoisted_79 = ["checked"]
const _hoisted_80 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold text-gray-800 fs-7 d-block" }, "Người phụ trách"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8" }, "Gán 1 nhân viên tư vấn trực tiếp phụ trách các ứng viên đã chọn.")
], -1)
const _hoisted_81 = ["checked"]
const _hoisted_82 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold text-gray-800 fs-7 d-block" }, "Nhóm phụ trách"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8" }, "Gán cho 1 nhóm tư vấn — nhóm tự phân bổ người phụ trách sau.")
], -1)
const _hoisted_83 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required" }, "Người phụ trách", -1)
const _hoisted_85 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_86 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required" }, "Nhóm phụ trách", -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer py-4 px-lg-8" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-light umt-btn-32",
    "data-bs-dismiss": "modal"
  }, "Hủy"),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary umt-btn-32",
    type: "submit"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-check me-1" }),
    /*#__PURE__*/_createTextVNode("Gán phụ trách")
  ])
], -1)
const _hoisted_88 = {
  class: "modal fade",
  id: "kt_modal_import",
  ref: "addExporResultModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_89 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_90 = { class: "modal-content" }
const _hoisted_91 = {
  class: "modal-header p-3",
  id: "kt_modal_add_customer_header"
}
const _hoisted_92 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Import danh sách ứng viên", -1)
const _hoisted_93 = {
  id: "kt_modal_add_customer_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_94 = { class: "svg-icon svg-icon-1" }
const _hoisted_95 = { class: "modal-body py-5 px-lg-8" }
const _hoisted_96 = { class: "bg-light rounded p-4 mb-4 fs-7 text-gray-700" }
const _hoisted_97 = { class: "d-flex align-items-start mb-2" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-circle badge-primary me-2 flex-shrink-0" }, "1", -1)
const _hoisted_99 = ["href"]
const _hoisted_100 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-start mb-2\"><span class=\"badge badge-circle badge-primary me-2 flex-shrink-0\">2</span><span>Điền đầy đủ thông tin ứng viên (CCCD, họ tên, ngày sinh, điểm, mã ngành, tổ hợp...) — chú ý giữ <b>số 0 đầu</b> của CCCD/SĐT (định dạng cột Text trong Excel). Địa chỉ thường trú dùng <b>mã tỉnh/xã 2 cấp mới</b> (sau sáp nhập) — mã không tra được sẽ có cảnh báo và để trống địa chỉ. File &quot;hồ sơ chưa đồng bộ&quot; tải từ tab <b>Đồng bộ nguyện vọng xét tuyển</b> chỉ để đối chiếu — <b>không</b> import trực tiếp.</span></div><div class=\"d-flex align-items-start\"><span class=\"badge badge-circle badge-primary me-2 flex-shrink-0\">3</span><span>Lưu định dạng <b>CSV UTF-8</b> rồi kéo thả (hoặc nhấn chọn) vào ô bên dưới — hệ thống import ngay khi thả file.</span></div>", 2)
const _hoisted_102 = /*#__PURE__*/_createElementVNode("form", {
  id: "id_dropzone",
  class: "dropzone w-100 mb-2"
}, null, -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8" }, "Kết quả sẽ báo: số ứng viên/hồ sơ import thành công · số dòng lỗi (kèm file danh sách lỗi để sửa rồi nạp lại).", -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer py-4 px-lg-8" }, [
  /*#__PURE__*/_createElementVNode("button", {
    "data-bs-dismiss": "modal",
    class: "btn btn-light",
    type: "button"
  }, "Đóng")
], -1)
const _hoisted_105 = {
  class: "modal fade umt-form",
  id: "kt_modal_dataentry_export",
  ref: "dataEntryExportModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_106 = { class: "modal-dialog modal-dialog-centered mw-550px" }
const _hoisted_107 = { class: "modal-content" }
const _hoisted_108 = { class: "modal-header p-3" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Xuất file nhập liệu", -1)
const _hoisted_110 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_111 = { class: "svg-icon svg-icon-1" }
const _hoisted_112 = { class: "modal-body py-5 px-lg-8" }
const _hoisted_113 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_114 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Người phụ trách", -1)
const _hoisted_115 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 mt-1" }, "Bắt buộc chọn để tránh xuất toàn bộ ứng viên (file quá lớn).", -1)
const _hoisted_116 = { class: "row g-3 mb-3" }
const _hoisted_117 = { class: "col-md-6" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tỉnh/TP (L12)", -1)
const _hoisted_119 = { class: "col-md-6" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Trường (L12)", -1)
const _hoisted_121 = { class: "col-md-6" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Năm tốt nghiệp", -1)
const _hoisted_123 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 mt-1" }, "Gồm cả hồ sơ chưa nhập năm (để bổ sung).", -1)
const _hoisted_124 = { class: "col-md-6" }
const _hoisted_125 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tình trạng tốt nghiệp", -1)
const _hoisted_126 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Số dòng mỗi file", -1)
const _hoisted_127 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 mt-1" }, "Từ 50 đến 500. Nếu vượt số này, hệ thống tự tách thành nhiều file.", -1)
const _hoisted_128 = { key: 0 }
const _hoisted_129 = { key: 0 }
const _hoisted_130 = { key: 1 }
const _hoisted_131 = { key: 1 }
const _hoisted_132 = {
  key: 0,
  class: "fs-7 text-gray-700 mb-2"
}
const _hoisted_133 = /*#__PURE__*/_createElementVNode("b", null, "thông tin cá nhân, địa chỉ, trường lớp, điểm học bạ (11 môn × 3 lớp), điểm thi TN (9 môn)", -1)
const _hoisted_134 = /*#__PURE__*/_createElementVNode("div", { class: "fs-8 text-muted mb-1" }, "Ứng viên trong danh sách xuất:", -1)
const _hoisted_135 = {
  class: "bg-light rounded p-3 fs-7",
  style: {"max-height":"200px","overflow-y":"auto"}
}
const _hoisted_136 = {
  key: 0,
  class: "text-muted mt-1 fst-italic"
}
const _hoisted_137 = { class: "modal-footer py-4 px-lg-8" }
const _hoisted_138 = /*#__PURE__*/_createElementVNode("button", {
  "data-bs-dismiss": "modal",
  class: "btn btn-light",
  type: "button"
}, "Hủy", -1)
const _hoisted_139 = ["disabled"]
const _hoisted_140 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search me-1" }, null, -1)
const _hoisted_141 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left me-1" }, null, -1)
const _hoisted_142 = ["disabled"]
const _hoisted_143 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-arrow-down me-1" }, null, -1)
const _hoisted_144 = {
  class: "modal fade",
  id: "kt_modal_import_dataentry",
  ref: "importDataEntryModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_145 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_146 = { class: "modal-content" }
const _hoisted_147 = { class: "modal-header p-3" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Nhập file nhập liệu ứng viên", -1)
const _hoisted_149 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_150 = { class: "svg-icon svg-icon-1" }
const _hoisted_151 = { class: "modal-body py-5 px-lg-8" }
const _hoisted_152 = /*#__PURE__*/_createElementVNode("div", { class: "bg-light rounded p-4 mb-4 fs-7 text-gray-700" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1" }, [
    /*#__PURE__*/_createTextVNode("Nhập lại chính "),
    /*#__PURE__*/_createElementVNode("b", null, "file đã xuất"),
    /*#__PURE__*/_createTextVNode(" (nút \"Xuất file nhập liệu\") sau khi TTV rà/sửa.")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1" }, [
    /*#__PURE__*/_createTextVNode("Khớp ứng viên theo cột "),
    /*#__PURE__*/_createElementVNode("b", null, "Mã định danh"),
    /*#__PURE__*/_createTextVNode(" (đừng sửa/xoá cột này và dòng tiêu đề).")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, [
    /*#__PURE__*/_createTextVNode("Ô để "),
    /*#__PURE__*/_createElementVNode("b", null, "trống = giữ nguyên"),
    /*#__PURE__*/_createTextVNode(" dữ liệu cũ (không xoá). Chỉ ghi ô có thay đổi; có kiểm tra hợp lệ + ghi lịch sử. "),
    /*#__PURE__*/_createElementVNode("b", null, "Không"),
    /*#__PURE__*/_createTextVNode(" đẩy Salesforce.")
  ])
], -1)
const _hoisted_153 = {
  key: 0,
  class: "text-muted fs-7"
}
const _hoisted_154 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-hourglass-split me-1" }, null, -1)
const _hoisted_155 = { class: "modal-footer py-4 px-lg-8" }
const _hoisted_156 = /*#__PURE__*/_createElementVNode("button", {
  "data-bs-dismiss": "modal",
  class: "btn btn-light",
  type: "button"
}, "Đóng", -1)
const _hoisted_157 = ["disabled"]
const _hoisted_158 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cloud-arrow-up me-1" }, null, -1)
const _hoisted_159 = {
  class: "modal fade",
  id: "kt_modal_export",
  ref: "exportModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_160 = { class: "modal-dialog modal-dialog-centered mw-550px" }
const _hoisted_161 = { class: "modal-content" }
const _hoisted_162 = {
  class: "modal-header p-3",
  id: "kt_modal_add_customer_header"
}
const _hoisted_163 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Xuất dữ liệu ứng viên", -1)
const _hoisted_164 = {
  id: "kt_modal_add_customer_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_165 = { class: "svg-icon svg-icon-1" }
const _hoisted_166 = { class: "modal-body py-5 px-lg-8" }
const _hoisted_167 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder" }, "Phạm vi xuất", -1)
const _hoisted_168 = ["checked"]
const _hoisted_169 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold text-gray-800 fs-7 d-block" }, "Tất cả ứng viên"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8" }, "Xuất toàn bộ danh sách ứng viên trong hệ thống.")
], -1)
const _hoisted_170 = ["checked"]
const _hoisted_171 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold text-gray-800 fs-7 d-block" }, "Theo người phụ trách"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8" }, "Chỉ xuất ứng viên do 1 nhân viên tư vấn phụ trách.")
], -1)
const _hoisted_172 = ["checked"]
const _hoisted_173 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold text-gray-800 fs-7 d-block" }, "Theo nhóm phụ trách"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8" }, "Chỉ xuất ứng viên thuộc 1 nhóm tư vấn.")
], -1)
const _hoisted_174 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_175 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required" }, "Người phụ trách", -1)
const _hoisted_176 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_177 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required" }, "Nhóm phụ trách", -1)
const _hoisted_178 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer py-4 px-lg-8" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-light umt-btn-32",
    "data-bs-dismiss": "modal"
  }, "Hủy"),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary umt-btn-32",
    type: "submit"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-excel me-1" }),
    /*#__PURE__*/_createTextVNode("Xuất Excel")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FilterBar = _resolveComponent("FilterBar")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_ModalDeleteAndReason = _resolveComponent("ModalDeleteAndReason")!
  const _component_CandidateQuickDrawer = _resolveComponent("CandidateQuickDrawer")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("ul", _hoisted_5, [
        _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_6, _hoisted_8)), [
          [_directive_permission, [_ctx.Permission.DASHBOARD_VIEW,_ctx.Permission.DASHBOARD]]
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-sm btn-light ms-auto umt-btn-32",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
      }, [
        _hoisted_9,
        _createTextVNode("Quay lại ")
      ])
    ]),
    (_ctx.badMajorCount > 0 || _ctx.dupIdCardCount > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_ctx.badMajorCount > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass((_ctx.badMajorCount > 0 && _ctx.dupIdCardCount > 0) ? 'col-md-6' : 'col-12')
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.badMajorCount) + " hồ sơ lỗi ngành", 1),
                    _hoisted_15
                  ]),
                  _createElementVNode("span", {
                    class: "text-primary fw-bold cursor-pointer text-decoration-underline text-nowrap ms-3 fs-7",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showBadMajorFilter && _ctx.showBadMajorFilter(...args)))
                  }, "Xem ngay"),
                  _hoisted_16,
                  _createElementVNode("span", {
                    class: "text-primary fw-bold cursor-pointer text-decoration-underline text-nowrap fs-7",
                    title: "Xuất danh sách để chia sẻ cho team",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.exportBannerList('badmajor')))
                  }, "Xuất Excel")
                ])
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.dupIdCardCount > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass((_ctx.badMajorCount > 0 && _ctx.dupIdCardCount > 0) ? 'col-md-6' : 'col-12')
              }, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.dupIdCardCount) + " ứng viên trùng CCCD", 1),
                    _hoisted_21
                  ]),
                  _createElementVNode("span", {
                    class: "text-primary fw-bold cursor-pointer text-decoration-underline text-nowrap ms-3 fs-7",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showDupIdCardFilter && _ctx.showDupIdCardFilter(...args)))
                  }, "Xem ngay"),
                  _hoisted_22,
                  _createElementVNode("span", {
                    class: "text-primary fw-bold cursor-pointer text-decoration-underline text-nowrap fs-7",
                    title: "Xuất danh sách để chia sẻ cho team",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.exportBannerList('dupidcard')))
                  }, "Xuất Excel")
                ])
              ], 2))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_FilterBar, {
          onFilterData: _ctx.filterData,
          onResetSearch: _cache[13] || (_cache[13] = ($event: any) => (_ctx.search = '')),
          selecting: _ctx.checkedCustomers.length > 0,
          ref: "filterList"
        }, {
          search: _withCtx(() => [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("span", _hoisted_26, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.search) = $event)),
                class: "form-control w-250px ps-11",
                style: {"height":"32px","min-height":"32px","padding-top":"0","padding-bottom":"0","font-size":"13px"},
                placeholder: "Tìm tên, SĐT, CCCD, MSSV..."
              }, null, 512), [
                [_vModelText, _ctx.search]
              ])
            ])
          ]),
          actions: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["justify-content-end", _ctx.checkedCustomers != 0?'d-none':'d-flex']),
              "data-kt-customer-table-toolbar": "base"
            }, [
              _createElementVNode("div", null, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                    to: "/themungvien",
                    class: "menu-item dropdown-item px-3 py-2 cursor-pointer d-flex align-items-center text-gray-800 fw-semibold text-hover-primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_29,
                      _createTextVNode("Thêm ứng viên ")
                    ]),
                    _: 1
                  })), [
                    [_directive_permission, [_ctx.Permission.STUDENT_CREATE,_ctx.Permission.STUDENT]]
                  ]),
                  _hoisted_30,
                  _withDirectives((_openBlock(), _createElementBlock("div", {
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.importFile && _ctx.importFile(...args))),
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#kt_modal_import",
                    class: "menu-item dropdown-item px-3 py-2 cursor-pointer d-flex align-items-center text-gray-800 fw-semibold text-hover-primary"
                  }, [
                    _hoisted_31,
                    _createTextVNode("Import ứng viên (.csv theo mẫu) ")
                  ])), [
                    [_directive_permission, [_ctx.Permission.STUDENT_IMPORT,_ctx.Permission.STUDENT]]
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("div", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleClickModalAssign(0))),
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#kt_modal_export",
                    class: "menu-item dropdown-item px-3 py-2 cursor-pointer d-flex align-items-center text-gray-800 fw-semibold text-hover-primary"
                  }, [
                    _hoisted_32,
                    _createTextVNode("Xuất dữ liệu ")
                  ])), [
                    [_directive_permission, [_ctx.Permission.STUDENT_EXPORT,_ctx.Permission.STUDENT]]
                  ]),
                  _hoisted_33,
                  _withDirectives((_openBlock(), _createElementBlock("div", {
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openDataEntryExport && _ctx.openDataEntryExport(...args))),
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#kt_modal_dataentry_export",
                    class: "menu-item dropdown-item px-3 py-2 cursor-pointer d-flex align-items-center text-gray-800 fw-semibold text-hover-primary"
                  }, [
                    _hoisted_34,
                    _createTextVNode("Xuất file nhập liệu (Excel) ")
                  ])), [
                    [_directive_permission, [_ctx.Permission.STUDENT_EXPORT,_ctx.Permission.STUDENT]]
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _hoisted_36,
                    _createTextVNode("Nhập file nhập liệu (Excel) ")
                  ])), [
                    [_directive_permission, [_ctx.Permission.STUDENT_IMPORT,_ctx.Permission.STUDENT]]
                  ])
                ])
              ])
            ], 2),
            (_ctx.checkedCustomers != 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createElementVNode("span", _hoisted_38, [
                    _hoisted_39,
                    _createTextVNode("Đã chọn " + _toDisplayString(_ctx.checkedCustomers.length) + " ", 1),
                    _createElementVNode("i", {
                      class: "bi bi-x-lg ms-2 cursor-pointer",
                      title: "Bỏ chọn tất cả",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.checkedCustomers = []; _ctx.checkDefault = false})
                    })
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", {
                    type: "button",
                    class: "btn btn-sm btn-light-success umt-btn-32 text-nowrap ms-auto",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#kt_modal_dataentry_export",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.openDataEntryExport && _ctx.openDataEntryExport(...args))),
                    title: `Xuất file nhập liệu cho ${_ctx.checkedCustomers.length} ứng viên đã chọn`
                  }, [
                    _hoisted_41,
                    _createTextVNode("Xuất file nhập liệu ")
                  ], 8, _hoisted_40)), [
                    [_directive_permission, [_ctx.Permission.STUDENT_EXPORT,_ctx.Permission.STUDENT]]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-primary umt-btn-32 text-nowrap",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#kt_modal_assign",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleClickModalAssign()))
                  }, [
                    _hoisted_42,
                    _createTextVNode("Gán phụ trách ")
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", {
                    type: "button",
                    class: "btn btn-sm btn-light-danger umt-btn-32 text-nowrap",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.callModalDelete())),
                    title: `Xóa ${_ctx.checkedCustomers.length} ứng viên đã chọn`
                  }, [
                    _hoisted_44,
                    _createTextVNode("Xóa (" + _toDisplayString(_ctx.checkedCustomers.length) + ") ", 1)
                  ], 8, _hoisted_43)), [
                    [_directive_permission, [_ctx.Permission.STUDENT_DELETE,_ctx.Permission.STUDENT]]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onFilterData", "selecting"]),
        (_ctx.tableData.length!=0)
          ? (_openBlock(), _createBlock(_component_Datatable, {
              key: 0,
              onCurrentChange: _ctx.currentChange,
              total: _ctx.pagination.total,
              currentPage: _ctx.pagination.currentPage,
              "table-data": _ctx.tableData,
              "table-header": _ctx.tableHeader,
              "rows-per-page": _ctx.pagination.limit,
              "enable-items-per-page-dropdown": true,
              onCurrentCheckAll: _ctx.checkAll,
              isCheck: _ctx.checkDefault,
              classTable: "uv-list"
            }, {
              "cell-checkbox": _withCtx(({ row: customer }) => [
                _createElementVNode("div", _hoisted_45, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input form-auto-check",
                    type: "checkbox",
                    value: customer.id,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.checkedCustomers) = $event))
                  }, null, 8, _hoisted_46), [
                    [_vModelCheckbox, _ctx.checkedCustomers]
                  ])
                ])
              ]),
              "cell-fullName": _withCtx(({ row: customer }) => [
                _createElementVNode("span", _hoisted_47, [
                  _createElementVNode("span", {
                    class: "text-primary fw-bold cursor-pointer text-hover-primary",
                    title: "Xem nhanh thông tin ứng viên",
                    onClick: ($event: any) => (_ctx.openQuickView(customer))
                  }, _toDisplayString(customer.fullName), 9, _hoisted_48),
                  (customer.hasWinner)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_49))
                    : _createCommentVNode("", true)
                ]),
                (!customer.leadid)
                  ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_50, _hoisted_52)), [
                      [_directive_tooltip, {
                    html: '<div class=\'p-2\'><div class=\'text-center\'><button class=\'me-auto btn btn-sm btn-primary\'>Click to Sync CRM</buttom></div></div>',
                    onClick: () =>_ctx.callSyncCRM(customer)
                  }]
                    ])
                  : _createCommentVNode("", true),
                (customer.studentcode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, "MSSV: " + _toDisplayString(customer.studentcode), 1))
                  : _createCommentVNode("", true)
              ]),
              "cell-phoneNumber": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachungvien/${customer.id}`,
                  class: "menu-link text-gray-800 text-hover-primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(customer.phoneNumber), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              "cell-location": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachungvien/${customer.id}`,
                  class: "menu-link text-gray-800 text-hover-primary text-nowrap"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(customer.location), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              "cell-school": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachungvien/${customer.id}`,
                  class: "menu-link text-gray-800 text-hover-primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(customer.school), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              "cell-idCard": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachungvien/${customer.id}`,
                  class: "menu-link text-gray-800 text-hover-primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(customer.idCard), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              "cell-numberProfile": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachungvien/${customer.id}`,
                  class: _normalizeClass(["menu-link d-block text-center text-hover-primary", customer.numberProfile == 0?'text-gray-400':'text-gray-800'])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(customer.numberProfile), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "class"])
              ]),
              "cell-date": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachungvien/${customer.id}`,
                  class: "menu-link text-gray-800 text-hover-primary"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("span", null, _toDisplayString(customer.date), 1),
                      (customer.updatedAt && new Date(customer.updatedAt).toLocaleDateString('en-GB') != customer.date)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_55, "Sửa: " + _toDisplayString(new Date(customer.updatedAt).toLocaleDateString('en-GB')), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              "cell-assignee": _withCtx(({ row: customer }) => [
                (customer.assignee)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: `/quanlyungvien/?assignee=${customer.assignee}`,
                      class: "menu-link text-gray-800 text-hover-primary text-nowrap"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.getInforName(_ctx.arrUsers,customer.assignee,'fullName')), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (customer.groupAssignee)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: `/quanlyungvien/?groupAssignee=${customer.groupAssignee}`,
                        class: "menu-link text-gray-800 text-hover-primary text-nowrap"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.getInforName(_ctx.arrGroups,customer.groupAssignee,'groupName')), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true)
              ]),
              "cell-highschoolGraduation": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachungvien/${customer.id}`,
                  class: "menu-link text-gray-800 text-hover-primary d-block text-end"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(`badge badge-light-${_ctx.statusTag[customer.highschoolGraduation]?.state} fw-normal`)
                    }, _toDisplayString(_ctx.statusTag[customer.highschoolGraduation]?.label), 3),
                    (customer.graduatedYear)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_56, "TN " + _toDisplayString(customer.graduatedYear), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              "cell-bgdsync": _withCtx(({ row: customer }) => [
                _createElementVNode("div", _hoisted_57, [
                  (customer.bgdsync?.transcript && customer.bgdsync?.graduationscore)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_58, "HB+TN ✓"))
                    : (customer.bgdsync?.transcript)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_59, "HB ✓"))
                      : (customer.bgdsync?.graduationscore)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_60, "TN ✓"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_61, "—"))
                ])
              ]),
              _: 1
            }, 8, ["onCurrentChange", "total", "currentPage", "table-data", "table-header", "rows-per-page", "onCurrentCheckAll", "isCheck"]))
          : (_openBlock(), _createBlock(_component_Datatable, {
              key: 1,
              "table-data": [],
              total: _ctx.tableData.length,
              currentPage: _ctx.pagination.currentPage,
              "table-header": _ctx.tableHeader,
              "rows-per-page": _ctx.pagination.limit,
              "enable-items-per-page-dropdown": false,
              onCurrentCheckAll: _ctx.checkAll,
              isCheck: _ctx.checkDefault,
              loading: _ctx.loading,
              "empty-table-text": _ctx.search ? 'Không có ứng viên nào khớp từ khóa đang tìm — bấm Đặt lại để xem toàn bộ danh sách' : 'Không có ứng viên nào khớp bộ lọc hiện tại — bấm Đặt lại để xem toàn bộ danh sách'
            }, null, 8, ["total", "currentPage", "table-header", "rows-per-page", "onCurrentCheckAll", "isCheck", "loading", "empty-table-text"]))
      ])
    ]),
    _createElementVNode("div", _hoisted_62, [
      _createElementVNode("div", _hoisted_63, [
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _hoisted_66,
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("span", _hoisted_68, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              ref: "assignFormRef",
              onSubmit: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
              model: _ctx.formData,
              rules: _ctx.rules,
              class: "umt-form"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                      _createTextVNode("Áp dụng cho "),
                      _createElementVNode("b", _hoisted_72, _toDisplayString(_ctx.checkedCustomers.length), 1),
                      _createTextVNode(" ứng viên đã chọn.")
                    ]),
                    (_ctx.assignCurrent.assigned > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                          _hoisted_74,
                          _createElementVNode("b", _hoisted_75, _toDisplayString(_ctx.assignCurrent.assigned) + "/" + _toDisplayString(_ctx.checkedCustomers.length), 1),
                          _createTextVNode(" đã có người phụ trách "),
                          (_ctx.assignCurrent.namesText)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_76, "(" + _toDisplayString(_ctx.assignCurrent.namesText) + ")", 1))
                            : _createCommentVNode("", true),
                          _createTextVNode(" — gán mới sẽ "),
                          _hoisted_77,
                          _createTextVNode(". ")
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_78,
                  _createElementVNode("label", {
                    class: _normalizeClass(["border rounded p-3 d-flex align-items-center gap-3 cursor-pointer text-start mb-2 w-100", _ctx.formData.typeOption == 1 ? 'border-primary bg-light-primary' : 'border-gray-300 border-dashed']),
                    onClick: _cache[15] || (_cache[15] = ($event: any) => {_ctx.formData.typeOption = 1; _ctx.handleChangeTypeOption()})
                  }, [
                    _createElementVNode("input", {
                      type: "radio",
                      class: "form-check-input flex-shrink-0",
                      checked: _ctx.formData.typeOption == 1,
                      style: {"pointer-events":"none"}
                    }, null, 8, _hoisted_79),
                    _hoisted_80
                  ], 2),
                  _createElementVNode("label", {
                    class: _normalizeClass(["border rounded p-3 d-flex align-items-center gap-3 cursor-pointer text-start mb-2 w-100", _ctx.formData.typeOption == 2 ? 'border-primary bg-light-primary' : 'border-gray-300 border-dashed']),
                    onClick: _cache[16] || (_cache[16] = ($event: any) => {_ctx.formData.typeOption = 2; _ctx.handleChangeTypeOption()})
                  }, [
                    _createElementVNode("input", {
                      type: "radio",
                      class: "form-check-input flex-shrink-0",
                      checked: _ctx.formData.typeOption == 2,
                      style: {"pointer-events":"none"}
                    }, null, 8, _hoisted_81),
                    _hoisted_82
                  ], 2),
                  (_ctx.formData.typeOption == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                        _hoisted_84,
                        _createVNode(_component_el_form_item, { prop: "assignee" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              class: "form-select-solid w-100",
                              placeholder: "Chọn người phụ trách",
                              modelValue: _ctx.formData.assignee,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.assignee) = $event)),
                              filterable: true
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrUsers, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.fullName+'/'+item.email,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.formData.typeOption == 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                        _hoisted_86,
                        _createVNode(_component_el_form_item, { prop: "groupAssignee" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              class: "form-select-solid w-100",
                              placeholder: "Chọn nhóm phụ trách",
                              modelValue: _ctx.formData.groupAssignee,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.groupAssignee) = $event)),
                              filterable: true
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrGroups, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.groupName+'/'+item.groupCode,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_87
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_88, [
      _createElementVNode("div", _hoisted_89, [
        _createElementVNode("div", _hoisted_90, [
          _createElementVNode("div", _hoisted_91, [
            _hoisted_92,
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("span", _hoisted_94, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("div", _hoisted_96, [
                _createElementVNode("div", _hoisted_97, [
                  _hoisted_98,
                  _createElementVNode("span", null, [
                    _createTextVNode("Tải "),
                    _createElementVNode("a", {
                      href: _ctx.sampleImportUrl,
                      class: "fw-bolder"
                    }, "file mẫu (.csv)", 8, _hoisted_99),
                    _createTextVNode(" — giữ nguyên tên cột.")
                  ])
                ]),
                _hoisted_100
              ]),
              _hoisted_102,
              _hoisted_103
            ]),
            _hoisted_104
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_105, [
      _createElementVNode("div", _hoisted_106, [
        _createElementVNode("div", _hoisted_107, [
          _createElementVNode("div", _hoisted_108, [
            _hoisted_109,
            _createElementVNode("div", _hoisted_110, [
              _createElementVNode("span", _hoisted_111, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_112, [
            (_ctx.deStep === 'filter')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.deUseSelection)
                    ? (_openBlock(), _createBlock(_component_el_alert, {
                        key: 0,
                        type: "info",
                        closable: false,
                        class: "mb-3"
                      }, {
                        title: _withCtx(() => [
                          _createTextVNode("Xuất "),
                          _createElementVNode("b", null, _toDisplayString(_ctx.checkedCustomers.length), 1),
                          _createTextVNode(" ứng viên đang chọn ở danh sách (bỏ qua bộ lọc dưới).")
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_ctx.deIsAdmin)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                              _hoisted_114,
                              _createVNode(_component_el_select, {
                                "popper-class": "umt-form-dd",
                                class: "w-100",
                                placeholder: "Chọn người phụ trách",
                                modelValue: _ctx.dataEntryExport.assignee,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.dataEntryExport.assignee) = $event)),
                                filterable: true
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrUsers, (u) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: u.id,
                                      label: u.fullName,
                                      value: u.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _hoisted_115
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_116, [
                          _createElementVNode("div", _hoisted_117, [
                            _hoisted_118,
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              class: "w-100",
                              placeholder: "Tất cả",
                              modelValue: _ctx.dataEntryExport.class12ProvinceId,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.dataEntryExport.class12ProvinceId) = $event)),
                              filterable: true,
                              onChange: _ctx.deGetSchool,
                              clearable: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deProvinces, (p) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: p.value,
                                    label: p.label,
                                    value: p.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _createElementVNode("div", _hoisted_119, [
                            _hoisted_120,
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              class: "w-100",
                              placeholder: "Tất cả",
                              modelValue: _ctx.dataEntryExport.class12SchoolId,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.dataEntryExport.class12SchoolId) = $event)),
                              filterable: true,
                              disabled: !_ctx.deSchools.length,
                              clearable: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deSchools, (s) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: s.value,
                                    label: s.label,
                                    value: s.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled"])
                          ]),
                          _createElementVNode("div", _hoisted_121, [
                            _hoisted_122,
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              class: "w-100",
                              placeholder: "Tất cả",
                              modelValue: _ctx.dataEntryExport.graduatedYear,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.dataEntryExport.graduatedYear) = $event)),
                              filterable: true,
                              clearable: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deYears, (y) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: y,
                                    label: y,
                                    value: y
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _hoisted_123
                          ]),
                          _createElementVNode("div", _hoisted_124, [
                            _hoisted_125,
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              class: "w-100",
                              placeholder: "Tất cả",
                              modelValue: _ctx.dataEntryExport.highschoolGraduation,
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.dataEntryExport.highschoolGraduation) = $event)),
                              clearable: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  label: "Chưa tốt nghiệp THPT",
                                  value: "not_graduated"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Chứng nhận TNTT",
                                  value: "temp_graduated"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Đã tốt nghiệp THPT",
                                  value: "graduated"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ])
                      ], 64)),
                  _createElementVNode("div", null, [
                    _hoisted_126,
                    _createVNode(_component_el_input_number, {
                      class: "w-100",
                      modelValue: _ctx.dataEntryExport.rowsPerFile,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.dataEntryExport.rowsPerFile) = $event)),
                      min: 50,
                      max: 500,
                      step: 50,
                      "controls-position": "right"
                    }, null, 8, ["modelValue"]),
                    _hoisted_127
                  ])
                ], 64))
              : (_ctx.dePreview)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_el_alert, {
                      type: _ctx.dePreview.total ? 'success' : 'warning',
                      closable: false,
                      class: "mb-3"
                    }, {
                      title: _withCtx(() => [
                        (_ctx.dePreview.total)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_128, [
                              _createTextVNode("Sẽ xuất "),
                              _createElementVNode("b", null, _toDisplayString(_ctx.dePreview.total), 1),
                              _createTextVNode(" ứng viên"),
                              (_ctx.dePreview.files > 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_129, [
                                    _createTextVNode(", chia "),
                                    _createElementVNode("b", null, _toDisplayString(_ctx.dePreview.files), 1),
                                    _createTextVNode(" file (mỗi file tối đa " + _toDisplayString(_ctx.dePreview.rpf) + " dòng)", 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_130, " (1 file)")),
                              _createTextVNode(".")
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_131, "Không có ứng viên nào khớp điều kiện — hãy đổi bộ lọc."))
                      ]),
                      _: 1
                    }, 8, ["type"]),
                    (_ctx.dePreview.total)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                          _createTextVNode("Mỗi ứng viên gồm: "),
                          _hoisted_133,
                          _createTextVNode(" — tổng " + _toDisplayString(_ctx.dePreview.cols) + " cột.", 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.dePreview.sample && _ctx.dePreview.sample.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_134,
                          _createElementVNode("div", _hoisted_135, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dePreview.sample, (n, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: i,
                                class: "text-gray-800"
                              }, _toDisplayString(i + 1) + ". " + _toDisplayString(n), 1))
                            }), 128)),
                            (_ctx.dePreview.total > _ctx.dePreview.sample.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_136, "… và " + _toDisplayString(_ctx.dePreview.total - _ctx.dePreview.sample.length) + " ứng viên khác", 1))
                              : _createCommentVNode("", true)
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_137, [
            (_ctx.deStep === 'filter')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_138,
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    type: "button",
                    disabled: _ctx.deExporting,
                    onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.fetchDataEntryPreview && _ctx.fetchDataEntryPreview(...args)))
                  }, [
                    _hoisted_140,
                    _createTextVNode(_toDisplayString(_ctx.deExporting ? 'Đang tải...' : 'Xem trước'), 1)
                  ], 8, _hoisted_139)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("button", {
                    class: "btn btn-light",
                    type: "button",
                    onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.deStep = 'filter'))
                  }, [
                    _hoisted_141,
                    _createTextVNode("Quay lại")
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    type: "button",
                    disabled: !_ctx.dePreview || !_ctx.dePreview.total,
                    onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.confirmDataEntryExport && _ctx.confirmDataEntryExport(...args)))
                  }, [
                    _hoisted_143,
                    _createTextVNode("Đồng ý, tải file ")
                  ], 8, _hoisted_142)
                ], 64))
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_144, [
      _createElementVNode("div", _hoisted_145, [
        _createElementVNode("div", _hoisted_146, [
          _createElementVNode("div", _hoisted_147, [
            _hoisted_148,
            _createElementVNode("div", _hoisted_149, [
              _createElementVNode("span", _hoisted_150, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_151, [
            _hoisted_152,
            _createElementVNode("input", {
              type: "file",
              accept: ".xls,.xlsx",
              class: "form-control mb-3",
              onChange: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.onDataEntryFilePicked && _ctx.onDataEntryFilePicked(...args)))
            }, null, 32),
            (_ctx.dataEntryImportLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
                  _hoisted_154,
                  _createTextVNode("Đang đọc file...")
                ]))
              : _createCommentVNode("", true),
            (_ctx.dataEntryImport)
              ? (_openBlock(), _createBlock(_component_el_alert, {
                  key: 1,
                  type: "success",
                  closable: false
                }, {
                  title: _withCtx(() => [
                    _createTextVNode(" Đã đọc "),
                    _createElementVNode("b", null, _toDisplayString(_ctx.dataEntryImport.fileName), 1),
                    _createTextVNode(" — "),
                    _createElementVNode("b", null, _toDisplayString(_ctx.dataEntryImport.rowCount), 1),
                    _createTextVNode(" dòng dữ liệu. ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_155, [
            _hoisted_156,
            _createElementVNode("button", {
              class: "btn btn-primary",
              type: "button",
              disabled: !_ctx.dataEntryImport || _ctx.dataEntrySubmitting,
              onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.submitDataEntryImport && _ctx.submitDataEntryImport(...args)))
            }, [
              _hoisted_158,
              _createTextVNode(_toDisplayString(_ctx.dataEntrySubmitting ? 'Đang nhập...' : 'Nhập dữ liệu'), 1)
            ], 8, _hoisted_157)
          ])
        ])
      ])
    ], 512),
    _createVNode(_component_ModalDeleteAndReason, {
      ref: "callFunctionModal",
      id: "callFunctionModal",
      title: "Bạn có muốn xóa các ứng viên này không?",
      onCallBackDelete: _ctx.deleteFewCustomers
    }, null, 8, ["onCallBackDelete"]),
    _createVNode(_component_CandidateQuickDrawer, { ref: "candidateQuickDrawer" }, null, 512),
    _createElementVNode("div", _hoisted_159, [
      _createElementVNode("div", _hoisted_160, [
        _createElementVNode("div", _hoisted_161, [
          _createElementVNode("div", _hoisted_162, [
            _hoisted_163,
            _createElementVNode("div", _hoisted_164, [
              _createElementVNode("span", _hoisted_165, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              ref: "exportFormRef",
              onSubmit: _withModifiers(_ctx.exportFileExcel, ["prevent"]),
              model: _ctx.formData,
              rules: _ctx.rules,
              class: "umt-form"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_166, [
                  _hoisted_167,
                  _createElementVNode("label", {
                    class: _normalizeClass(["border rounded p-3 d-flex align-items-center gap-3 cursor-pointer text-start mb-2 w-100", _ctx.formData.typeOption == 0 ? 'border-primary bg-light-primary' : 'border-gray-300 border-dashed']),
                    onClick: _cache[31] || (_cache[31] = ($event: any) => {_ctx.formData.typeOption = 0; _ctx.handleChangeTypeOption()})
                  }, [
                    _createElementVNode("input", {
                      type: "radio",
                      class: "form-check-input flex-shrink-0",
                      checked: _ctx.formData.typeOption == 0,
                      style: {"pointer-events":"none"}
                    }, null, 8, _hoisted_168),
                    _hoisted_169
                  ], 2),
                  _createElementVNode("label", {
                    class: _normalizeClass(["border rounded p-3 d-flex align-items-center gap-3 cursor-pointer text-start mb-2 w-100", _ctx.formData.typeOption == 1 ? 'border-primary bg-light-primary' : 'border-gray-300 border-dashed']),
                    onClick: _cache[32] || (_cache[32] = ($event: any) => {_ctx.formData.typeOption = 1; _ctx.handleChangeTypeOption()})
                  }, [
                    _createElementVNode("input", {
                      type: "radio",
                      class: "form-check-input flex-shrink-0",
                      checked: _ctx.formData.typeOption == 1,
                      style: {"pointer-events":"none"}
                    }, null, 8, _hoisted_170),
                    _hoisted_171
                  ], 2),
                  _createElementVNode("label", {
                    class: _normalizeClass(["border rounded p-3 d-flex align-items-center gap-3 cursor-pointer text-start mb-2 w-100", _ctx.formData.typeOption == 2 ? 'border-primary bg-light-primary' : 'border-gray-300 border-dashed']),
                    onClick: _cache[33] || (_cache[33] = ($event: any) => {_ctx.formData.typeOption = 2; _ctx.handleChangeTypeOption()})
                  }, [
                    _createElementVNode("input", {
                      type: "radio",
                      class: "form-check-input flex-shrink-0",
                      checked: _ctx.formData.typeOption == 2,
                      style: {"pointer-events":"none"}
                    }, null, 8, _hoisted_172),
                    _hoisted_173
                  ], 2),
                  (_ctx.formData.typeOption == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
                        _hoisted_175,
                        _createVNode(_component_el_form_item, { prop: "assignee" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              class: "form-select-solid w-100",
                              placeholder: "Chọn người phụ trách",
                              modelValue: _ctx.formData.assignee,
                              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.formData.assignee) = $event)),
                              filterable: true
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrUsers, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.fullName+'/'+item.email,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.formData.typeOption == 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_176, [
                        _hoisted_177,
                        _createVNode(_component_el_form_item, { prop: "groupAssignee" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              class: "form-select-solid w-100",
                              placeholder: "Chọn nhóm phụ trách",
                              modelValue: _ctx.formData.groupAssignee,
                              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.formData.groupAssignee) = $event)),
                              filterable: true
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrGroups, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.groupName+'/'+item.groupCode,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_178
              ]),
              _: 1
            }, 8, ["onSubmit", "model", "rules"])
          ])
        ])
      ])
    ], 512)
  ])), [
    [_directive_permission, [_ctx.Permission.STUDENT_VIEW,_ctx.Permission.STUDENT]]
  ])
}